import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import {
  CreateLeadDTO, CreateLeadResponseDTO, LeadAnswersDTO, UpdateLeadResponseDTO,
} from '../../models/crm-lead';

// The CRM is a separate service (crm.avantti.io) that authenticates each lead
// with its own token, so this api skips baseQueryWithReauth: an error here must
// never log the producer out nor toast. The onboarding treats the CRM as
// best-effort and keeps going when it fails.
const crmLeadsApi = createApi({
  reducerPath: 'crmLeadsApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${config.crmUrl}/api/public/` }),
  endpoints: (build) => ({
    createLead: build.mutation<CreateLeadResponseDTO, CreateLeadDTO>({
      query: (body) => ({
        url: 'leads',
        method: 'POST',
        body,
      }),
    }),
    // `contact` corrects the name or WhatsApp of screen 1 on the same lead
    // instead of creating a second one.
    updateLead: build.mutation<UpdateLeadResponseDTO, {
      leadId: string, token: string, answers?: LeadAnswersDTO, contact?: { name?: string, whatsapp?: string },
    }>({
      query: ({
        leadId, token, answers = {}, contact,
      }) => ({
        url: `leads/${leadId}`,
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
        body: { answers, ...contact },
      }),
    }),
  }),
});

export const { useCreateLeadMutation, useUpdateLeadMutation } = crmLeadsApi;
export { crmLeadsApi };
